module.exports = __webpack_public_path__ + "static/media/10-cubes-h.d5971ce3.png";